// extracted by mini-css-extract-plugin
export default {"mainContainer":"MedicalEmergenciesMainScreen_mainContainer__cPL7c"};